//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { exportFile } from "@/api/downloadRequest";
import regionSeatLibs from '@/utils/regionSeatLibs.js'
let regionData = JSON.parse(JSON.stringify(regionSeatLibs[0].c))
export default {
    name: 'MoneyIntentionList',
    data() {
        return {
            filterForm: {
                applyDate:'',
                bankName:'',
                startTime:'',
                endTime:''
            },
            regionProps: {
                value: 'i',
                label: 'n',
                children: 'c',
                checkStrictly: true
            },
            checkedRegionData:[],
            regionData: regionData,
            pagination: {
                currentPage: 1,
                pageSize: 10,
                total: 0,
            },
            tableData: [],
            applyDate:''
        };
    },
    created() {
        this.getFinanceLoanIntentionList();
    },
    methods: {
        //页码切换
        handleCurrentChange(val) {
            this.pagination.currentPage = val;
            this.getFinanceLoanIntentionList();
        },
        // 获取列表数据
        getFinanceLoanIntentionList() {
            let params = {
                ...this.filterForm,
                isOwner:0,
                currentPage:this.pagination.currentPage,
                pageSize:this.pagination.pageSize
            }
            this.$http.bank.getFinanceLoanIntentionList(params).then(res => {
                this.pagination.total = res.data.recordTotal;
                this.$set(this,'tableData',res.data.content)
            })
        },
        // 导出
        handleToExport(){
            this.$http.bank.financeLoanIntentionExport({...this.filterForm,isOwner:0}).then( res => {
                exportFile(res.data, "贷款意向查询列表", "xlsx");
            })
        },
        // 下拉补贴地区选完关闭
        handleRegionChange(val) {
            this.$refs.regionCascader.dropDownVisible = false
            let _params = this.filterForm
            _params.provinceId = val[0] || ''
            _params.cityId = val[1] || ''
            _params.countyId = val[2] || ''
        },
        // 跳详情
        handleToDetail(row){
            this.$router.push({
                path:'/money/intention/detail',
                query:{
                    id:row.id,
                    businessOutlets:row.businessOutlets,
                    region:row.region
                }
            })
        },
        // 查询
        handleFilter() {
            this.pagination.currentPage = 1;
            this.getFinanceLoanIntentionList();
        },
        //重置
        handleReset(formName) {
            this.$refs[formName].resetFields();
            this.checkedRegionData = []
            this.applyDate = ''
            let _params = this.filterForm
            _params.provinceId = ''
            _params.cityId = ''
            _params.countyId = ''
            _params.startTime = ''
            _params.endTime = ''
            setTimeout(() => {
                this.handleFilter();
            }, 500);
        },
        // 银行机构
        bankAssociate(key,cb) {
            if (key !== '') {
                this.loading = true;
                this.$http.bank.fuzzyQueryList({key}).then( ({data}) => {
                this.loading = false;
                let arr = data.map( (item,index) => ({name:item,value:index}));
                cb(arr) // 渲染回调
                }).catch( res => {
                this.loading = false;
                })
            }
        },
        changeApplyDate(val) {
            if (val && val.length > 1) {
                this.filterForm.startTime = val[0];
                this.filterForm.endTime = val[1];
            } else {
                this.filterForm.startTime = "";
                this.filterForm.endTime = "";
            }
        },
    },
};
